export function toComparableLowerCase(text: string) {
    return deaccentText(text).toLowerCase()
}

function deaccentText(text: string) {
    return text.normalize('NFD').replace(/\p{Diacritic}/gu, '')
}
